import styled from 'styled-components';
import { Space } from 'antd';

export const IconWrapper = styled.div`
  font-size: 16px;
  align-items: center;
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
`;

export const BoolIconWrapper = styled.div`
  font-size: 16px;
  align-items: center;
  display: flex;
  width: 100%;
  height: 100%;
  opacity: ${({ disabled }) => disabled ? '0.5' : '1'};
`;

export const ToolboxWrapper = styled.div`
  display: flex;
  .ant-radio-button-wrapper-checked {
    svg {
      path {
        fill: #3fa3ff;
      }
      path[stroke-linecap="round"] {
        stroke: #3fa3ff;
      }
    }
  }
  .ant-radio-button-wrapper-disabled {
    svg {
      path {
        fill: #D9D9D9;
      }
      path[stroke-linecap="round"] {
        stroke: #D9D9D9;
      }
    }
  }
  .ant-radio-button-wrapper {
    border: 0px;
    border-right: 1px solid #aaa;
    border-right-color: #aaa !important;
  }
  .ant-radio-button-wrapper:last-child {
    border-right: 0px;
  }
  .ant-radio-button-wrapper::before {
    background-color: #aaa;
  }
`;

export const Subscript = styled.span`
  font-size: small;
  padding-left: 4px;
  &:empty {
    display: none;
  }
`;

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 5px;
  margin: 0;
  vertical-align: top;
  font-size: 17px;
  font-weight: 400;
  color: #595959;

  .chart-title{
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    font-weight: 500;
    display: inline-block;
    max-width: calc(100% - 20px);
  }

  .na-text{
    color:#a6a4a4;
    font-weight:400;
  }
`;

export const TitleWrapper = styled.div`
  padding-left: 5px;
  margin-right: 10px;
  text-overflow: ellipsis;
  overflow: hidden;
  }
  h4 {
    display: flex;
    align-items: center;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  span {
    font-weight: 300;
  }
`;

export const LiveModeMarker = styled.div`
  height: 8px;
  width: 8px;
  border-radius: 50%;
  display: inline-block;
  background-color: red;
  margin-right: 5px;
`;

export const SecondRow = styled.div`
  display: flex;
  padding-left: 5px;
`;

export const ValueWrapper = styled.div`
  font-size: 18px;
  color: #000;
  font-weight: 500;
  display: flex;
  align-items: center
`;

export const DiagWrapper = styled.div`
  margin: 0px 5px;
  font-size: 24px;
  line-height: 0;
  cursor: pointer;
  height: 24px;
  width: 24px;
  border-radius: 6px;
  background-color: white;
`

export const StyledCloseBtn = styled.div`
  position: absolute;
  right: 15px;
  color: #595959;
  top: 5px;
`;

export const IconWrap = styled.span`
  display: flex;
  font-size: 0.8em;
  margin-left: 5px;
  color: #595959;`;

export const StyledDistributionToggle =  styled(Space)`
  flex: 1;
  text-align: center;
  align-items: end;
  justify-content: center;
`;

export const SecondaryMetricWrapper = styled.div`
  position: relative;
  min-height: 150px;
  border-top: 5px solid #d8e0e6;
`;

export const SecondaryMetricHeader = styled.div`
  padding: 10px;
  display: flex;
`;


export const TotalTag = styled.div`
  position: relative;
`;

export const FilterTagBar = styled.span`
  border: 3px solid ${(props) => props.color};
`;
